import React, {ReactElement, useState} from "react";
import classes from './Gallery.module.scss'
import clsx from "clsx";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft, faChevronRight} from "@fortawesome/pro-light-svg-icons";

type Props = {
	children: JSX.Element[];
}

export const GalleryView = (props: Props): ReactElement<Props> => {
	const [currentPos, setCurrentPos] = useState(0);
	const [leftOrRight, setLeftOrRight] = useState("0");

	function moveLeft() {
		if (currentPos === props.children.length - 1) {
			setCurrentPos(0)
		} else {
			setCurrentPos(currentPos + 1)
		}
		setLeftOrRight("2");
	}

	function moveRight() {
		if (currentPos === 0) {
			setCurrentPos(props.children.length - 1)
		} else {
			setCurrentPos(currentPos - 1)
		}
		setLeftOrRight("1");
	}

	function handleLeftRight(item: any, index: any, leftRight1: any, leftRight2: any) {
		if (currentPos === 0) {
			if (index === props.children.length - 1) {
				return (
					// @ts-ignore
					<div leftorright={leftOrRight} className={clsx(classes.photo, leftRight1)} onClick={moveRight}>
						{item}
					</div>
				)
			}
		}
		if (currentPos === props.children.length - 1) {
			if (index === 0) {
				return (
					// @ts-ignore
					<div leftorright={leftOrRight} className={clsx(classes.photo, leftRight2)} onClick={moveLeft}>
						{item}
					</div>
				)
			}
		}
		if (index === currentPos + 1) {
			return (
				// @ts-ignore
				<div leftorright={leftOrRight} className={clsx(classes.photo, leftRight2)} onClick={moveLeft}>
					{item}
				</div>
			)
		} else if (index === currentPos) {
			return (
				// @ts-ignore
				<div leftorright={leftOrRight} className={clsx(classes.photo, classes.spotlight)}>
					{item}
				</div>
			)
		} else if (index === currentPos - 1) {
			return (
				// @ts-ignore
				<div leftorright={leftOrRight} className={clsx(classes.photo, leftRight1)} onClick={moveRight}>
					{item}
				</div>
			)
		} else if (index < currentPos - 1) {
			return (
				// @ts-ignore
				<div leftorright={leftOrRight} className={clsx(classes.photo, classes.bellow)}>
					{item}
				</div>
			)
		} else if (index > currentPos - 1) {
			return (
				// @ts-ignore
				<div leftorright={leftOrRight} className={clsx(classes.photo, classes.bellow)}>
					{item}
				</div>
			)
		}
	}

	return (
		<div className={classes.container}>
			<FontAwesomeIcon
				size='3x'
				icon={faChevronLeft}
				className={clsx(classes.buttons, classes.button_left)}
				onClick={moveRight}/>
			<div className={classes.gallery}>
				{props.children.map((item, index) => {
					return (
						leftOrRight === "2" ?
							handleLeftRight(item, index, classes.right, classes.left)
							:
							handleLeftRight(item, index, classes.left, classes.right)
					)
				})}
			</div>
			<FontAwesomeIcon
				size='3x'
				icon={faChevronRight}
				className={clsx(classes.buttons, classes.button_right)}
				onClick={moveLeft}/>
		</div>
	)
}